import React from 'react';
import styles from './CurrentlyPlayingCard.module.scss';
import CardImage from 'next/image';
import { loaderUrl, squareImageLoader } from 'utils/cloudinary';
import { Card } from '@yleisradio/areena-types';
import { BackgroundImage } from 'components/Player/AudioPlayerWrapper/ExpandedAudioPlayer/BackgroundImage';
import { getProgramTitleWithStartTime } from 'utils/card';

type Props = {
  ongoingCard: Card | undefined;
  upcomingCard: Card | undefined;
  isRadioChannel: boolean;
};

export const CurrentlyPlayingCard = ({
  ongoingCard,
  upcomingCard,
  isRadioChannel,
}: Props) => {
  const { title, description, image } = ongoingCard || {};

  const ongoingTitle = getProgramTitleWithStartTime(ongoingCard);
  const upcomingTitle = getProgramTitleWithStartTime(upcomingCard);

  const primaryText = isRadioChannel ? ongoingTitle : title;
  const secondaryText = isRadioChannel ? upcomingTitle : description;

  return (
    <div>
      <BackgroundImage image={image} />
      <div className={styles.card}>
        <div className={styles.imageContainer}>
          {image && (
            <div className={styles.imageWrapper}>
              <CardImage
                src={loaderUrl(image)}
                alt=""
                fill
                role="presentation"
                sizes={'(min-width: 640px) 44vw, 100vw'}
                loader={squareImageLoader}
                className={styles.image}
              />
            </div>
          )}
        </div>

        <div className={styles.textContainer}>
          <p className={styles.primaryText}>{primaryText || ''}</p>
          <p className={styles.secondaryText}>{secondaryText || ''}</p>
        </div>
      </div>
    </div>
  );
};
